import { PageOptions } from "./global";
import { getUserTraits } from "./segment";

export function page(data: PageOptions = {}): void {
  try {
    const userTraits = getUserTraits();
    const optionalProperties = data.properties ? data.properties : {};
    const combinedProperties = { ...userTraits, ...optionalProperties };
    window?.analytics?.page(data.name, combinedProperties);
  } catch (error) {
    console.error("Failed to track page event.", error);
  }
}
